import { Plug, Workflow, Sparkles, ShieldCheck } from "lucide-react"

export const HERO_BADGES = [
  { key: "integrations", icon: Plug, color: "bg-blue-500" },
  { key: "automation", icon: Workflow, color: "bg-green-600" },
  { key: "ai", icon: Sparkles, color: "bg-purple-600" },
  { key: "care", icon: ShieldCheck, color: "bg-blue-800" },
] as const
